import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store';
import i18n from '@/i18n';

const PageNotFound = () => import('@/containers/main/PageNotFound');
const Login = () => import('@/containers/main/Login');
import Dashboard from '@/containers/dashboard/Dashboard';
import CustomDashboard from '@/containers/dashboard/CustomDashboard';

const Main = () => import('@/containers/main');
const EventStatus = () => import('@/containers/event/eventStatus/EventStatus');
const EventSettings = () => import('@/containers/event/eventSettings/EventSettings');
const EventFilter = () => import('@/containers/event/eventFilter/EventFilter');
const AlarmGroup = () => import('@/containers/event/alarmGroup/AlarmGroupMain');

const PerformanceList = () => import('@/containers/performance/PerformanceList');
const LogDashboard = () => import('@/containers/logs/logDashboard/LogDashboard');
const LogCollections = () => import('@/containers/logs/logCollections/LogCollections');
const LogMetricManage = () => import('@/containers/logs/logMetricManage/LogMetricManage');
const AgentManage = () => import('@/containers/agent/AgentManage');

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: '/', redirect: '/dashboard' },
    { path: '/notfound', component: PageNotFound },
    { path: '/login', component: Login },
    {
      path: '/dashboard',
      component: Main,
      children: [
        {
          path: '',
          component: Dashboard,
          name: 'monitoringDashboard',
          meta: {
            name: 'menu.monitoringDashboard' //'모니터링 대시보드'
          }
        }
      ]
    },
    {
      path: '/customDashboard',
      component: Main,
      children: [
        {
          path: '',
          component: CustomDashboard,
          name: 'customDashboard',
          meta: {
            name: 'menu.customDashboard' //'사용자 정의 대시보드'
          }
        }
      ]
    },
    {
      path: '/performanceList',
      component: Main,
      children: [
        {
          path: '',
          component: PerformanceList,
          name: 'performanceList',
          props: () => ({
            productTypeCode: store.getters.getParameters('performanceList')['productTypeCode']
          }),
          meta: {
            name: 'menu.performanceAnalysis' //'성능 분석'
          }
        }
      ]
    },
    {
      path: '/logs',
      component: Main,
      name: 'log',
      meta: {
        name: 'menu.logAnalysis' //'로그 분석'
      },
      children: [
        {
          path: 'logDashboard',
          component: LogDashboard,
          name: 'log-dashboard',
          meta: {
            name: 'menu.logDashboard' //'로그 수집 대시보드'
          }
        },
        {
          path: 'logCollections',
          component: LogCollections,
          name: 'log-collections',
          meta: {
            name: 'menu.logStatus' //'로그 현황'
          },
          props: () => ({
            productTypeCode: store.getters.getParameters('log-collections')['productTypeCode'],
            productName: store.getters.getParameters('log-collections')['productName'],
            productSq: store.getters.getParameters('log-collections')['productSq']
          })
        },
        {
          path: 'logMetricManage',
          component: LogMetricManage,
          name: 'log-logmetricManage',
          meta: {
            name: 'menu.metricSettingStatus' //'지표 설정 현황'
          },
          props: () => ({
            productTypeCode: store.getters.getParameters('log-logmetricManage')['productTypeCode'],
            productName: store.getters.getParameters('log-logmetricManage')['productName']
          })
        }
      ]
    },
    {
      path: '/event',
      component: Main,
      name: 'event',
      meta: {
        name: 'menu.eventManagement' //'이벤트 관리'
      },
      children: [
        {
          path: 'eventStatus',
          component: EventStatus,
          name: 'event-status',
          meta: {
            name: 'menu.eventStatus' //'이벤트 현황'
          }
        },
        {
          path: 'eventSettings',
          component: EventSettings,
          name: 'event-settings',
          props: true,
          meta: {
            name: 'menu.eventSettings' //'이벤트 설정'
          }
        },

        {
          path: 'eventFilter',
          component: EventFilter,
          name: 'event-filter',
          meta: {
            name: 'menu.eventFiltering' //'이벤트 필터링'
          }
        },
        {
          path: 'alarmAddrs',
          component: AlarmGroup,
          name: 'event-alarmAddrs',
          meta: {
            name: 'menu.alarmGroup' //'알림 주소록'
          }
        }
      ]
    },
    {
      path: '/agentManage',
      component: Main,
      children: [
        {
          path: '',
          component: AgentManage,
          name: 'agentManage',
          meta: {
            name: 'menu.agentManagement'
          }
        }
      ]
    }
  ]
});
router.getTitle = () => {
  const current = router.currentRoute.value;
  return i18n.global.t(current.meta.name);
};
router.getRouteItem = () => {
  const matched = router.currentRoute.value.matched;
  let routeItem = [];
  for (let i in matched) {
    let name = matched[i].meta.name;
    if (name) routeItem.push({ text: i18n.global.t(name) });
  }
  return routeItem;
};
router.beforeEach(function (to, from, next) {
  store.commit('setLoading', false);
  beforeCheck(to, from, next);
});

/* eslint-disable */
function getCookie(name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length == 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, exp) {
  var date = new Date();
  date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
}

function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=0';
}

function isPath(str) {
  if (
    str == '/login' ||
    str == '/regist' ||
    // str == "/home" ||
    str == '/profile' ||
    str == '/sso' ||
    str == '/reset/auth/code' ||
    str.startsWith('/pop')
  ) {
    return true;
  } else {
    return false;
  }
}

function beforeCheck(to, from, next) {
  afterLoginCheck(to, from, next);
}

function afterLoginCheck(to, from, next) {
  next();
}

export default router;
